<template>
<div>
  <div v-if="loading">
    <v-progress-linear
      indeterminate
      color="primary"
      ></v-progress-linear>
  </div>
  <v-container fluid>
    <search-bar
        v-model="query.search"
        v-on:clear="clearSearch"
        :label="searchLabel"
        v-on:request-search="onRequestSearch"
    />
    <v-text-field
    clearable
    class="mt-1"
    solo
    append-icon="mdi-magnify"
    label="Search by tag"
    v-model="query.search_tag"
    v-on:click:append="requestTagSearch"
    v-on:keydown.enter="requestTagSearch"
    v-on:click:clear="clearTagSearch"
    ></v-text-field>
    <v-row>
        <v-col sm="12" md="6" cols="12">
            <v-autocomplete
              solo
              required
              autocomplete="off"
              label="Filter by category"
              item-text="name"
              clearable
              @click:clear="clearCategoryCallback"
              @change="categorySelected"
              item-value="id"
              v-bind:items="categories"
          ></v-autocomplete>
        </v-col>
        <v-col sm="12" md="6" cols="12">
          <v-text-field
            label="Select date"
            solo
            clearable
            readonly
            v-model="formattedDate"
            @click:clear="dateClearCallback"
            prepend-icon="mdi-calendar"
            @click="showDatePicker"
          ></v-text-field>
        </v-col>
    </v-row>

    </v-container>
    <v-pagination
      v-if="this.pagination != undefined && this.pagination.totalItems > 0"
      v-model="pagination.currentPage"
      circle
      v-bind:length="pagination.pageCount"
      v-on:input = "onRequestPageChange"
    ></v-pagination>
    <div v-if="!loading && this.news !== null">
      <v-row class="ma-1">
        <v-col
          v-if="(news?news:[]).length<=0"
        >
          <v-banner
            single-line
            class="text-h6"
          >
            No records
          </v-banner>
        </v-col>
        <v-col
          cols="md-6 sm-12"
          v-for="item in news"
          :key="item.id"
          class="d-flex child-flex"
        >
          <news-card class="mb-4" :showPriorityField="showPriorityOrderField" :post="item" @priorityChanged="priorityChangeCallback" @deleted="deleteSuccessCallback"></news-card>
        </v-col>
      </v-row>
    </div>
    <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>
</div>
</template>

<script>
import postApi from '@/api/postApi'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import * as dateFormats from '@/constants/dateFormats'
export default {
  components: {
    'news-card': () => import('@/components/NewsCard'),
    'search-bar': () => import('@/components/SearchBar'),
    DatePickerDialog
  },
  mounted () {
    // when returning from edit/add
    if (window.publish_date) {
      this.query.publish_date = window.publish_date
      window.publish_date = null
      this.formattedDate = this.$moment(this.query.publish_date).format(dateFormats.DDMMYY)
    }
    this.init()
  },
  data: function () {
    return {
      searchLabel: 'Search for title or body',
      breadCrumbs: [
        {
          text: 'News list',
          disabled: true
        }
      ],
      showDatePickerDialog: false,
      categories: [],
      loading: false,
      showPriorityOrderField: false,
      query: {
        search: null,
        search_tag: null,
        sort: 'publish_date:desc',
        category_id: null,
        publish_date: null,
        page: 1,
        item_per_page: 16

      },
      formattedDate: null,
      news: null,
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      },
      sortItems: [
        { text: 'Newest first', value: 'created_at:desc' },
        { text: 'Oldest first', value: 'created_at:asc' }
      ]
    }
  },
  methods: {
    requestTagSearch () {
      this.query.page = 1
      this.fetchNews()
    },
    priorityChangeCallback () {
      this.$log.info('priority change callback @newslist')
      this.fetchNews()
    },
    clearCategoryCallback () {
      this.$log.info('Clear category callback', [this.query.category_id])
      this.query.category_id = null
      this.togglePriorityField()
      this.fetchNews(this.query)
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.query.publish_date = null
      this.togglePriorityField()
      this.fetchNews(this.query)
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.query.publish_date = dateUtils.parseDate(data)
      this.togglePriorityField()
      this.fetchNews()
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    togglePriorityField () {
      this.$log.info('togglel priority field', [this.query.publish_date, this.query.category_id])
      if (this.query.publish_date && this.query.category_id) {
        this.showPriorityOrderField = true
        this.query.sort = 'order:asc'
      } else {
        this.showPriorityOrderField = false
        this.query.sort = 'publish_date:desc'
      }
    },
    async init () {
      this.loading = true
      this.fetchCategory()
      await this.fetchNews()
    },
    async fetchCategory () {
      const response = await postApi.getCategories()
      if (response.data !== undefined) {
        this.$log.info('fetch category', [response.data])
        this.categories = response.data
      }
    },
    categorySelected (catId) {
      this.$log.info('category selected', [catId])
      this.query.category_id = catId
      this.togglePriorityField()
      this.fetchNews()
    },

    deleteSuccessCallback () {
      this.fetchNews()
    },
    onRequestSort () {
      this.fetchNews()
    },
    onRequestSearch () {
      this.query.page = 1
      this.fetchNews()
    },
    clearTagSearch () {
      this.query.search_tag = null
      this.fetchNews()
    },
    clearSearch () {
      this.query.search = null
      this.fetchNews()
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchNews()
    },
    async fetchNews () {
      this.$log.info('Fetching news params', [this.query])
      this.loading = true
      try {
        const response = await postApi.getNews(this.query)
        if (response.data.data !== undefined) {
          this.news = response.data.data
          this.parsePaginationData(response.data)
        }
      } finally {
        this.loading = false
      }
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    }
  }
}
</script>
